<template>
    <div class="form-edit-page">
        <div class="page-header">
            <div>
                <h1>ITEM 56 - Inspeção de Supervisão do Estabelecimento</h1>
                <p class="page-subtitle">
                    Laudo de inspeção sanitária anual do estabelecimento
                </p>
            </div>

            <div class="header-actions">
                <button class="btn btn-secondary" @click="abaAtiva = 'formulario'">
                    Formulário
                </button>
                <button class="btn btn-primary" @click="abaAtiva = 'emissao'">
                    Emitir Laudo
                </button>
            </div>
        </div>

        <template v-if="abaAtiva === 'formulario'">
            <InspecaoSupervisaoEstabelecimentoCabecalho
                v-model="form.cabecalho"
            />

            <InspecaoSupervisaoEstabelecimentoItens
                v-model:itens="form.itens"
                v-model:observacoes="form.observacoes"
            />

            <InspecaoSupervisaoEstabelecimentoFinalizacao
                v-model="form.finalizacao"
                :totais="totais"
            />
        </template>

        <template v-else>
            <InspecaoSupervisaoEstabelecimentoEmissao
                :cabecalho="form.cabecalho"
                :itens="form.itens"
                :observacoes="form.observacoes"
                :finalizacao="form.finalizacao"
                :totais="totais"
                :secoes="supervisaoEstabelecimentoSecoes"
            />
        </template>
    </div>
</template>

<script setup>
import { computed, reactive, ref } from 'vue'
import InspecaoSupervisaoEstabelecimentoCabecalho from './InspecaoSupervisaoEstabelecimentoCabecalhoB.vue'
import InspecaoSupervisaoEstabelecimentoItens from './InspecaoSupervisaoEstabelecimentoItensB.vue'
import InspecaoSupervisaoEstabelecimentoFinalizacao from './InspecaoSupervisaoEstabelecimentoFinalizacaoB.vue'
import InspecaoSupervisaoEstabelecimentoEmissao from './InspecaoSupervisaoEstabelecimentoEmissaoB.vue'
import { supervisaoEstabelecimentoSecoes } from './inspecaoSupervisaoEstabelecimento_56B.js'

const abaAtiva = ref('formulario')

const criarItensIniciais = () => {
    const map = {}
    supervisaoEstabelecimentoSecoes.forEach(secao => {
        secao.subgrupos.forEach(subgrupo => {
            subgrupo.itens.forEach(item => {
                map[item.codigo] = {
                    situacao: '',
                    observacao: '',
                }
            })
        })
    })
    return map
}

const criarObservacoesIniciais = () => {
    const map = {}
    supervisaoEstabelecimentoSecoes.forEach(secao => {
        secao.subgrupos.forEach(subgrupo => {
            map[subgrupo.codigo] = ''
        })
    })
    return map
}

const form = reactive({
    cabecalho: {
        numeroLaudo: 'SIM XX/01/2025',
        razaoSocial: 'Estabelecimento Exemplo Ltda',
        nomeFantasia: 'Frigorífico Modelo',
        numeroRegistroSim: '025',
        inscricaoEstadual: '',
        cnpjCpf: '',
        endereco: '',
        bairro: '',
        municipio: 'Araranguá',
        cep: '',
        uf: 'SC',
        telefone: '',
        email: '',
        dataInspecao: '',
        classificacaoEstabelecimento: '',
        possuiResponsavelTecnico: 'S',
        responsavelTecnicoQual: '',
        nomeResponsavelTecnico: '',
        formacaoAcademica: '',
        numeroPessoasAtividade: 0,
        numeroTurnos: 1,
        nomeAcompanhante: '',
        cpfAcompanhante: '',
        funcaoAcompanhante: '',
        motivoInspecao: 'LAUDO DE INSPEÇÃO SANITÁRIA ANUAL',
        motivoOutros: '',
    },
    itens: criarItensIniciais(),
    observacoes: criarObservacoesIniciais(),
    finalizacao: {
        disposicao: 'Prazo de 10 (dez) dias úteis para entregar por escrito ao SIM o PLA 08 - Relatório de Ações Corretivas (RAC), descrevendo as medidas adotadas para cada um dos itens supracitados.',
        totalNAInformado: 0,
        totalConformesInformado: 0,
        percentualConformidadeInformado: 0,
        grupoClassificacao: '',
        conclusaoFiscal: '',
        nomeResponsavelInspecao1: '',
        matriculaResponsavelInspecao1: '',
        assinaturaResponsavelInspecao1: '',
        nomeResponsavelInspecao2: '',
        matriculaResponsavelInspecao2: '',
        assinaturaResponsavelInspecao2: '',
        nomeResponsavelEmpresa: '',
        assinaturaResponsavelEmpresa: '',
        nomeTestemunha: '',
        assinaturaTestemunha: '',
        cidadeAssinatura: 'Araranguá',
        dataAssinatura: '',
    }
})

const totais = computed(() => {
    const respostas = Object.values(form.itens)

    const conforme = respostas.filter(r => r.situacao === 'C').length
    const conformeRestricao = respostas.filter(r => r.situacao === 'CR').length
    const naoConforme = respostas.filter(r => r.situacao === 'NC').length
    const naoAplicavel = respostas.filter(r => r.situacao === 'NA').length
    const totalItens = respostas.length
    const itensUtilizaveis = totalItens - naoAplicavel

    const percentualConformidade = itensUtilizaveis > 0
        ? Number(((conforme / itensUtilizaveis) * 100).toFixed(2))
        : 0

    let grupo = 'GRUPO 03'
    if (percentualConformidade >= 85) grupo = 'GRUPO 01'
    else if (percentualConformidade >= 61) grupo = 'GRUPO 02'

    return {
        totalItens,
        conforme,
        conformeRestricao,
        naoConforme,
        naoAplicavel,
        itensUtilizaveis,
        percentualConformidade,
        grupo,
    }
})
</script>

<style scoped>
.form-edit-page {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.page-header {
    background: #fff;
    border: 1px solid #d8dee8;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: center;
}

.page-header h1 {
    margin: 0 0 6px;
    font-size: 22px;
    color: #1f2937;
}

.page-subtitle {
    margin: 0;
    color: #6b7280;
}

.header-actions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.btn {
    border: none;
    border-radius: 8px;
    padding: 10px 14px;
    font-weight: 600;
    cursor: pointer;
}

.btn-primary {
    background: #2563eb;
    color: #fff;
}

.btn-secondary {
    background: #e5e7eb;
    color: #111827;
}
</style>